import { render, staticRenderFns } from "./PrepageMainServices.vue?vue&type=template&id=9a5409ae&scoped=true&"
import script from "./PrepageMainServices.vue?vue&type=script&lang=js&"
export * from "./PrepageMainServices.vue?vue&type=script&lang=js&"
import style0 from "./PrepageMainServices.vue?vue&type=style&index=0&id=9a5409ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5409ae",
  null
  
)

export default component.exports